export interface HeroSlide {
  id: string;
  title: string;
  tag: string;
  intro: string;
  image: string;
  link: string;
}

export const heroSlides: HeroSlide[] = [
  {
    id: 's1',
    title: '长夜星河',
    tag: '古装权谋 · 热播中',
    intro: '寒门书生入仕朝堂，在权谋漩涡中点亮属于自己的星河。评分 9.1，本季度最大黑马。',
    image: 'https://readdy.ai/api/search-image?query=epic%20cinematic%20wide%20shot%20of%20an%20ancient%20Chinese%20palace%20rooftop%20at%20night%20under%20a%20vast%20starry%20sky%2C%20lone%20figure%20in%20flowing%20dark%20blue%20robe%2C%20deep%20indigo%20and%20gold%20tones%2C%20dramatic%20moody%20lighting%2C%20no%20text&width=1600&height=900&seq=hero-slide-01&orientation=landscape',
    link: '/detail/tv/changye',
  },
  {
    id: 's2',
    title: '雾城谜案',
    tag: '悬疑刑侦 · 高分口碑',
    intro: '十年大雾掩盖七宗旧案，刑警江澈在追凶途中重新面对自己的过去。评分 9.3。',
    image: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20foggy%20neon%20city%20street%20at%20night%20with%20a%20lone%20detective%20silhouette%20holding%20an%20umbrella%2C%20cold%20teal%20and%20crimson%20neon%20reflections%20on%20wet%20asphalt%2C%20suspenseful%20atmosphere%2C%20no%20text&width=1600&height=900&seq=hero-slide-02&orientation=landscape',
    link: '/detail/tv/wucheng',
  },
  {
    id: 's3',
    title: '长安十二时',
    tag: '历史群像 · 长尾出圈',
    intro: '长安城一日，人间十二年。以十二个时辰为轴，绘就一幅鲜活的长安众生相。评分 9.4。',
    image: 'https://readdy.ai/api/search-image?query=panoramic%20cinematic%20view%20of%20a%20magnificent%20ancient%20Tang%20dynasty%20city%20at%20dusk%20with%20glowing%20red%20lanterns%2C%20palace%20towers%20and%20crowds%20in%20traditional%20clothing%2C%20rich%20crimson%20and%20gold%20tones%2C%20grand%20scale%2C%20no%20text&width=1600&height=900&seq=hero-slide-03&orientation=landscape',
    link: '/detail/tv/changan',
  },
  {
    id: 's4',
    title: '国产都市剧正在"去爽感化"？',
    tag: '行业观察 · 深度',
    intro: '从《逆光而行》到《季风起时》，越来越多都市剧开始弱化逆袭爽感，转而描摹真实的成长困境。',
    image: 'https://readdy.ai/api/search-image?query=abstract%20modern%20city%20skyline%20at%20blue%20hour%20seen%20through%20geometric%20glass%20architecture%2C%20cool%20azure%20and%20grey%20tones%2C%20clean%20minimal%20editorial%20composition%2C%20no%20text&width=1600&height=900&seq=hero-slide-04&orientation=landscape',
    link: '/detail/news/n005',
  },
  {
    id: 's5',
    title: '星辰之下',
    tag: '奇幻爱情 · 新上架',
    intro: '天文社少年能在流星划过时看见未来，为了改变心上人消失的结局，他决定与时间赛跑。',
    image: 'https://readdy.ai/api/search-image?query=dreamy%20cinematic%20wide%20shot%20of%20two%20figures%20standing%20on%20a%20hilltop%20under%20a%20glowing%20starry%20night%20sky%20with%20a%20bright%20meteor%2C%20dreamy%20indigo%20and%20soft%20pink%20nebula%20tones%2C%20whimsical%20romantic%20atmosphere%2C%20no%20text&width=1600&height=900&seq=hero-slide-05&orientation=landscape',
    link: '/detail/tv/xingchen',
  },
];